export default () => {
  const prependPound = number => {
    return '£' + number
  }

  const round = number => {
    return number.toFixed(2)
  }

  return {
    init ($form) {
      const $lineLength = $form.querySelector('.js-elc-line-length')
      const $costAerosol = $form.querySelector('.js-elc-cost-aerosol')

      const $aerosolsNeeded100 = $form.querySelector(
        '.js-elc-aerosols-needed[data-line-width="100"]'
      )
      const $aerosolsNeeded75 = $form.querySelector(
        '.js-elc-aerosols-needed[data-line-width="75"]'
      )
      const $aerosolsNeeded50 = $form.querySelector(
        '.js-elc-aerosols-needed[data-line-width="50"]'
      )

      const $pricePerMetre100 = $form.querySelector(
        '.js-elc-price-per-metre[data-line-width="100"]'
      )
      const $pricePerMetre75 = $form.querySelector(
        '.js-elc-price-per-metre[data-line-width="75"]'
      )
      const $pricePerMetre50 = $form.querySelector(
        '.js-elc-price-per-metre[data-line-width="50"]'
      )
      const $errorLine = $form.querySelector('.js-elc-error[data-error="line"]')
      const $errorCost = $form.querySelector('.js-elc-error[data-error="cost"]')

      $form.addEventListener('submit', e => {
        e.preventDefault()

        let lineLength = $lineLength.value
        let costAerosol = $costAerosol.value

        // Error handling
        let hasError = false
        if (!lineLength) {
          // if nothing is entered into the field
          $errorLine.innerText = 'Please set a value'
          hasError = true
        }

        if (isNaN(lineLength)) {
          // if Line Length is anything other than a number including specials
          $errorLine.innerText = 'Please enter only numbers'
          hasError = true
        }

        if (lineLength.length > 10) {
          $errorLine.innerText = 'That number is too large'
          hasError = true
        }

        if (isNaN(costAerosol)) {
          // if Line Length is anything other than a number including specials
          $errorCost.innerText = 'Please enter only numbers'
          hasError = true
        }

        if (hasError) {
          return
        }

        $errorLine.innerText = ''
        $errorCost.innerText = ''

        $aerosolsNeeded100.innerText = Math.ceil(lineLength / 50)
        $aerosolsNeeded75.innerText = Math.ceil(lineLength / 75)
        $aerosolsNeeded50.innerText = Math.ceil(lineLength / 100)

        if (costAerosol) {
          $pricePerMetre100.innerText = prependPound(
            round(costAerosol * $aerosolsNeeded100.innerText / lineLength)
          )
          $pricePerMetre75.innerText = prependPound(
            round(costAerosol * $aerosolsNeeded75.innerText / lineLength)
          )
          $pricePerMetre50.innerText = prependPound(
            round(costAerosol * $aerosolsNeeded50.innerText / lineLength)
          )
        } else {
          $pricePerMetre100.innerText = prependPound(round(0))
          $pricePerMetre75.innerText = prependPound(round(0))
          $pricePerMetre50.innerText = prependPound(round(0))
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core/easyline_calculator.js